import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-danchuang(1)",
  "use": "icon-danchuang(1)-usage",
  "viewBox": "0 0 35 35",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 35 35\" id=\"icon-danchuang(1)\">\r\n  <path id=\"icon-danchuang(1)_danchuang\" d=\"M19.576,16.776l8.365-8.327v6.612a1.008,1.008,0,1,0,2.017,0V6.025a1.007,1.007,0,0,0-1.01-1H19.872a1.007,1.007,0,1,0,0,2.006h6.642l-8.368,8.325a1,1,0,0,0,0,1.422,1.012,1.012,0,0,0,1.427,0ZM30.964,0H6.76A4.032,4.032,0,0,0,2.722,4.017V15.061a1.01,1.01,0,0,0,2.019,0V4.017A2.016,2.016,0,0,1,6.76,2.008h24.2a2.019,2.019,0,0,1,2.019,2.008v24.1a2.017,2.017,0,0,1-2.019,2.008H19.872a1.007,1.007,0,1,0,0,2.006H30.964A4.027,4.027,0,0,0,35,28.116V4.012A4.026,4.026,0,0,0,30.97,0h0ZM2.708,18.846H13.532a2.382,2.382,0,0,1,2.7,2.692V32.308A2.385,2.385,0,0,1,13.529,35H2.706A2.386,2.386,0,0,1,0,32.308V21.538a2.384,2.384,0,0,1,2.706-2.692Z\" fill=\"#fff\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/danchuang(1).svg
// module id = qDO9
// module chunks = 5